<template>
    <div class="header-btn-lg">

        <button @click="onMenuRightOpen" v-show="!menuButtonsRight" type="button" class="hamburger hamburger--elastic open-right-drawer">
            <span class="hamburger-box"><span class="hamburger-inner"></span></span>
        </button>
    </div>
</template>

<script>
    export default {
        name: "t-app-menu-right-button",
        data(){
            return{
            }
        },
        computed: {
            menuButtonsRight(){
                return this.$store.getters.getCurrentPageMenuButtonsRight
            }
        },
        methods: {
            onMenuRightOpen() {
                this.$store.commit("setPageMenuButtonsRight",true)
                this.$store.commit("setPageBlackoutShow",true)
            }
        }
    }
</script>

<style scoped>

</style>
